<script setup lang="ts">
/**
 * Lien texte « … › » des pages charte « apple » (Karim 2026-10-18), avec
 * l'effet validé sur /dashboard : soulignement qui se dessine de gauche à
 * droite et chevron qui avance au survol. `to` → lien, sinon <button>.
 * `clair` : sur fond noir (bleu lumineux #2997ff, lisible sur le noir).
 */
import type { CibleLien } from "~/types/cibleLien";
import { NuxtLink } from "#components";

const props = withDefaults(defineProps<{ to?: CibleLien; clair?: boolean }>(), {
  to: undefined,
  clair: false,
});
</script>

<template>
  <component
    :is="props.to ? NuxtLink : 'button'"
    :to="props.to"
    :type="props.to ? undefined : 'button'"
    class="lien-apple"
    :class="props.clair && 'lien-apple--clair'"
  >
    <span class="lien-apple-texte"><slot /></span>
    <UIcon name="i-lucide-chevron-right" class="lien-apple-chevron" aria-hidden="true" />
  </component>
</template>

<style scoped>
.lien-apple {
  --ease: cubic-bezier(0.28, 0, 0.22, 1);
  display: inline-flex;
  align-items: center;
  gap: 2px;
  min-height: 44px;
  font-size: 17px;
  font-weight: 600;
  color: var(--color-main);
  cursor: pointer;
}
.lien-apple--clair {
  color: #2997ff;
}
.lien-apple-texte {
  position: relative;
}
.lien-apple-texte::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -2px;
  height: 1.5px;
  border-radius: 2px;
  background: currentColor;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 350ms var(--ease);
}
.lien-apple-chevron {
  width: 16px;
  height: 16px;
  transition: transform 350ms var(--ease);
}
@media (hover: hover) {
  .lien-apple:hover .lien-apple-texte::after {
    transform: scaleX(1);
  }
  .lien-apple:hover .lien-apple-chevron {
    transform: translateX(4px);
  }
}
.lien-apple:focus-visible {
  outline: none;
  border-radius: 8px;
  box-shadow: 0 0 0 4px color-mix(in oklab, var(--color-main), transparent 65%);
}
@media (prefers-reduced-motion: reduce) {
  .lien-apple-texte::after,
  .lien-apple-chevron {
    transition-duration: 1ms !important;
  }
}
</style>
